/** @jsxImportSource @emotion/react */
import { useState } from "react";
import ProductoEnActividad from "./ProductoEnActividad";
import ArchivosDisponibles from "../ArchivosDisponibles";
import MuestrasProceso from "../MuestrasProceso";
import BotonDescargarProductos from "../BotonDescargarProductos";
import PasosAnteriores from "../PasosAnteriores";
import FormularioEnsayo from "../pasoIngreso/FormularioEnsayo";
import { Titulo } from "../../../shared";
import { Card } from "primereact/card";

export default function PasoRevision({
  actividad,
  archivosPaso,
  archivoAgregado,
  pasoId,
  paso,
  modoLectura,
}) {
  const [productos, setProductos] = useState(
    actividad.proceso.producto.filter((p) => p.vigente === 1)
  );

  const actualizarProductos = (productosActualizados) => {
    setProductos(productosActualizados.filter((p) => p.vigente === 1));
  };

  return (
    <div className="grid">
      <div
        className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12"
        css={{ display: "flex", flexDirection: "column", gap: "1em" }}
      >
        <Card>
          <Titulo><i className="pi pi-history" css={{ marginRight: "0.5em" }}></i>Pasos anteriores</Titulo>
          <PasosAnteriores pasosAnteriores={paso.decisionesAnteriores} />
        </Card>
        <Card>
          <FormularioEnsayo
            pasoId={pasoId}
            normaId={actividad.proceso.norma?.id}
            reportesEnActividad={actividad.reporteensayo}
            modoLectura={modoLectura}
          />
        </Card>
        <ArchivosDisponibles
          archivosOriginales={archivosPaso}
          archivoAgregado={archivoAgregado}
          pasoId={pasoId}
          modoLectura={modoLectura}
          procesoNombre={actividad.proceso.nombre}
        />
        <MuestrasProceso pasoId={pasoId} />
      </div>

      <div
        className="col-12 xl:col-6 lg:col-6 md:col-12 sm:col-12"
        css={{ display: "flex", flexDirection: "column", gap: "1em" }}
      >
        <Card>
          <Titulo
            botones={
              <BotonDescargarProductos
                pasoId={pasoId}
                proceso={actividad.proceso}
                productos={productos}
              />
            }
          >
            <i className="pi pi-box" css={{ marginRight: "0.5em" }}></i>
            Productos para verificación
          </Titulo>
          {productos.map((producto) => {
            return (
              <ProductoEnActividad
                key={producto.id}
                producto={producto}
                pasoId={pasoId}
                onProductosActualizados={actualizarProductos}
                modoLectura={modoLectura}
              />
            );
          })}
        </Card>
      </div>
    </div>
  );
}
